// Loading.tsx
export default function Loading() {
  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50"
      style={{ pointerEvents: 'none' }}
    >
      <img
        src="/Loading.gif"
        alt="Loading..."
        className="w-32 h-32"
      />
    </div>
  );
}
